/**
 * Re-sync cart UI when the browser restores a page from the back-forward cache
 */
(function () {
  "use strict";

  let refreshInFlight = false;

  const getShopifyRoot = () => window.Shopify?.routes?.root || "/";

  const buildSectionsUrl = (sectionIds) => {
    const base = getShopifyRoot().replace(/\/?$/, "/");
    return `${base}?sections=${sectionIds.join(",")}&v=${Date.now()}`;
  };

  const syncRelatedCartUi = () => {
    const pageItems = document.querySelector("cart-items");
    if (pageItems && typeof pageItems.onCartUpdate === "function") {
      pageItems.onCartUpdate();
    }

    const hasAddToCart = document.querySelector("[js-add-to-cart]");
    const scheduleAtcRefresh = window.theme?.cartQuantityLimits?.scheduleRefreshAtcState;
    if (hasAddToCart && scheduleAtcRefresh) {
      scheduleAtcRefresh();
    }
  };

  async function refreshCartAfterBackForwardRestore() {
    if (refreshInFlight) return;

    const drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.getSectionsToRender !== "function" || typeof drawer.renderContents !== "function") {
      return;
    }

    const sectionIds = drawer
      .getSectionsToRender()
      .map((section) => section.id)
      .filter(Boolean);
    if (sectionIds.length === 0) return;

    refreshInFlight = true;
    try {
      const response = await fetch(buildSectionsUrl(sectionIds), {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!response.ok) throw new Error("Cart section refresh failed");

      const sections = await response.json();
      if (!sections?.cart) return;

      drawer.renderContents({ sections });
      syncRelatedCartUi();
    } catch (error) {
      console.error(error);
    } finally {
      refreshInFlight = false;
    }
  }

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    refreshCartAfterBackForwardRestore();
  });
})();
